import { useContext, useState } from 'react'
import { OtherContext } from '../../../context api/Others/OtherContext'
import { useRestApi } from '../../../lib/RestApi/useRestApi'
import { API_URL } from '../../../shared/actions'

export const useAuditTask = () => {
  const [auditTask, setAuditTask] = useState(false)
  const { deleteNewAuditTask, getNewAuditTask } = useContext(OtherContext)
  const [loading, setLoading] = useState(false)
  const [paginate, setPaginate] = useState(false)

  const { ADD, GET_ALL, UPDATE, GET_SINGLE_DATA, DELETE } = useRestApi(setLoading, 'AuditTask', '', 'GET_ALL_AUDIT_TASK')
  const {
    AUDIT_TASK: { GET_ALL_AUDIT_TASK, EDIT_AUDIT_TASK, DELETE_MANY_AUDIT_TASK },
  } = API_URL

  const getAllAuditTask = async (dto = {}) => {
    GET_ALL(GET_ALL_AUDIT_TASK, setPaginate, getNewAuditTask, dto)
  }
  const addTask = (dto) => {
    ADD('CREATE_TASK', dto)
  }

  const updateAuditTask = (dto) => {
    UPDATE('EDIT_POS_TASK', dto)
  }

  const updateAuditsTask = (dto) => {
    UPDATE('EDIT_AUDIT_TASK', dto)
  }

  const getAuditTask = (dto) => {
    GET_SINGLE_DATA(GET_ALL_AUDIT_TASK, setAuditTask, dto)
  }

  const deleteManyAuditTask = (dto, setSelected = () => {}) => {
    console.log({ dto })
    DELETE(DELETE_MANY_AUDIT_TASK, dto, 'auditTaskId', setSelected, deleteNewAuditTask, 'GET_ALL_AUDIT_TASK')
  }

  return {
    getAllAuditTask,
    getAuditTask,
    auditTask,
    updateAuditTask,
    deleteManyAuditTask,
    loading,
    paginate,
    addTask,
    updateAuditsTask,
  }
}
